export default class ofertaAcademicaClass {
    constructor(planAcademico) {
        let ofertaAcademica = planAcademico.ofertaacademica.filter(x => x.mostrar !== "N");

        ofertaAcademica.forEach((x, i) => {
            x.index = i;

            this.splitHorarioPorDias(x);

            x.esVirtual = (x.virtual !== "N");
            x.horario.forEach(h => { x.esVirtual = x.esVirtual || h.horainicio === h.horafin });
            x.horario.map(horario => this.getHorario(horario));
            let horariosHash = x.horario.map(x => x.hash);
            x.id = `${x.idmateria}_${horariosHash}`;
        });

        let materiasSugeridas = ofertaAcademica.filter(x => x.sugerida === "Y");

        let materiasAlternativas = ofertaAcademica.filter(x => {
            if (x.sugerida === "Y") return false;

            let isInMateriasSugeridas = (materiasSugeridas.some(y => y.id === x.id));
            if (isInMateriasSugeridas) return false;

            return true;
        });

        let materiasAlternativasID = materiasAlternativas.map(x => x.id);
        materiasAlternativasID = [...new Set(materiasAlternativasID)]; //remove duplicates

        let materiasAlternativas2 = materiasAlternativasID.map(id => materiasAlternativas.filter(m => m.id === id)[0]);
        materiasAlternativas = materiasAlternativas2;

        //clonar materias por valor, para no afectar la oferta original
        this.materiasSugeridas = JSON.parse(JSON.stringify(materiasSugeridas));
        this.materiasAlternativas = JSON.parse(JSON.stringify(materiasAlternativas));

    }

    splitHorarioPorDias = (materia) => {
        var horarios = [];
        materia.horario.forEach(horario => {
            const dias = horario.dia.split(',').map(x => x.trim());
            if (dias.length > 1) {
                dias.forEach(dia => {
                    horario.dia = dia;
                    horarios.push(JSON.parse(JSON.stringify(horario)));
                });
            } else {
                //debugger;
                horarios.push(horario);
            }
        });

        materia.horario = horarios;
    }

    getHorario = (h) => {
        const getFormattedTime = (time) => {
            const d = new Date('2024-01-01 ' + time);
            const hours = ('0' + (d.getHours() % 12 || 12)).substr(-2);
            const mins = ('0' + (d.getMinutes())).substr(-2);
            return `${hours}:${mins}`;
        };

        const hashCode = (str) => {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code = str.charCodeAt(i);
                hash = ((hash << 5) - hash) + code;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        }

        h.hash = hashCode(JSON.stringify(h))
        h.horainicionum = Number(h.horainicio.replace(":", ""));
        h.horafinnum = Number(h.horafin.replace(":", "")) - 0.01;
        //h.horafinnum = h.horainicionum + (h.horas * 100) - 0.01;
        //debugger;
        h.horainicioDisplay = getFormattedTime(h.horainicio);
        h.horafinDisplay = getFormattedTime(h.horafin);
        h.diaNombre = this.getNombreDia(h.dia);
        h.diaNombreCorto = this.getNombreDiaCorto(h.dia);
        h.displayCaption = h.diaNombreCorto ? `${h.diaNombreCorto}: ${h.horainicioDisplay} - ${h.horafinDisplay}` : ``;
        return h;
    };

    getNombreDia = (d) => {
        d = d.toUpperCase();
        if (d === 'L') return "Lunes";
        if (d === 'M') return "Martes";
        if (d === 'MI') return "Miercoles";
        if (d === 'J') return "Jueves";
        if (d === 'V') return "Viernes";
        if (d === 'S') return "Sabado";
        if (d === 'D') return "Domingo";
        return undefined;
    };

    getNombreDiaCorto = (d) => {
        d = this.getNombreDia(d);
        if (!d) return d;
        return d.substring(0, 3);
    };

    static seEmpalmaHorario = (h1, h2) => {
        if (!h1.horas) return false;
        if (!h2.horas) return false;
        if (h1.dia !== h2.dia) return false;
        if (h1.horainicionum >= h2.horainicionum && h1.horainicionum <= h2.horafinnum) return true;
        if (h1.horafinnum >= h2.horainicionum && h1.horafinnum <= h2.horafinnum) return true;
        return false;
    };

    static seEmpalmaMateria = (m1, m2) => {
        let seEmpalma = m1.horario.filter(h => h.horas).some(h1 => {
            return m2.horario.filter(h => h.horas).some(h2 => {
                return this.seEmpalmaHorario(h1, h2) || this.seEmpalmaHorario(h2, h1);
            });
        });

        return seEmpalma;
    };

}
